import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProviderStatementBalanceEmailTemplate.UploadAttachment.IRequest;
type Response = Api.Core.ProviderStatementBalanceEmailTemplate.UploadAttachment.IResponse;
type Headers = Api.Core.ProviderStatementBalanceEmailTemplate.UploadAttachment.IHeaders;
const apiProviderStatementBalanceEmailTemplateUploadAttachmentPath =
  '/api/Management/ProviderStatementBalanceEmailTemplate/:id/UploadAttachment';
export default async function providerStatementBalanceEmailTemplateUploadAttachmentApi(
  id: number,
  request: Request
): Promise<Api.Res<Response>> {
  const res = await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiProviderStatementBalanceEmailTemplateUploadAttachmentPath, { id }, null),
    method: HttpMethod.post,
    headers: getDefaultHeaders(),
  });
  return res;
}
